import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { appStore } from "src/appStore";
import { catalogsLoader } from "src/business/catalog/apiCatalog";
import { catalogColumns } from "src/business/catalog/catalogColumns";
import { CatalogFilters, ZCatalog } from "src/business/catalog/ZCatalog";
import { MdmTable, MdmTableSystemTools } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { RtSearch } from "src/components/ReactiveTable/components/RtSearch";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ToolBox2 } from "src/components/ToolBox2";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

export const CatalogsPage: React.FC = observer(() => (
  <PageLayout title="Каталоги">
    <ToolBox2
      paddingMode="page"
      mainTool={<RtSearch store={pageStore.table} />}
      extraTools={<MdmTableSystemTools store={pageStore.table} />}
    >
      <MdmTable
        store={pageStore.table}
        columns={pageStore.columns}
        resizableColumns
        rowClick={{
          type: "link",
          builder: (row) => makeUrl(PageUrl.records, { id: row.id }),
        }}
      />
    </ToolBox2>
  </PageLayout>
));

const pageStore = makeAutoObservable({
  table: new RtStore<ZCatalog, CatalogFilters>({
    rowKey: "id",
    loader: catalogsLoader(),
  }),
  get columns() {
    return catalogColumns({ showScheme: false, settings: this.showSettings });
  },
  get showSettings(): boolean {
    return !!appStore.isMetadataEditor;
  },
});
